import React from "react";
import { FaShippingFast, FaMapMarkedAlt, FaBoxOpen } from "react-icons/fa";

import "../styles/ShippingPage.css";

const ShippingPage = () => {
  return (
    <div className="shipping-page">
      <div className="shipping-header">
        <h1>Shipping <span>Information</span></h1>
        <p>
          We ensure fast, safe, and reliable delivery for all SAC MTB bikes and accessories
          across India. Here’s everything you need to know before placing your order.
        </p>
      </div>

      <div className="shipping-container">
        {/* Delivery Time */}
        <div className="shipping-card">
          <FaShippingFast className="shipping-icon" />
          <h3>🚚 Delivery Time</h3>
          <p>
            Orders are typically dispatched within <strong>2–4 business days</strong>.
            Delivery times vary by location but usually take <strong>5–7 business days</strong>.
          </p>
        </div>

        {/* Shipping Policy */}
        <div className="shipping-card">
          <FaBoxOpen className="shipping-icon" />
          <h3>📦 Shipping Policy</h3>
          <p>
            We partner with trusted couriers for all shipments. Each product is securely packed
            to prevent damage during transit. In rare cases of visible damage, please refuse
            the delivery and contact our support immediately.
          </p>
        </div>

        {/* Tracking Orders */}
        <div className="shipping-card">
          <FaMapMarkedAlt className="shipping-icon" />
          <h3>🗺️ Tracking Orders</h3>
          <p>
            Once your order ships, you’ll receive a tracking link via email or SMS.
            You can track your order in real-time through our <strong>Order Tracking</strong> section.
          </p>
        </div>
      </div>

      <div className="shipping-note">
        <p>
          ⚠️ <strong>Note:</strong> Delivery to remote or hilly regions may take additional time.
          SAC MTB is committed to delivering your order as quickly and safely as possible.
        </p>
      </div>
    </div>
  );
};

export default ShippingPage;
